import { p } from "./_helpers";

const artisanat = {
 slug: "artisanat",
 path: "/secteurs/artisanat",
 hero: {
 image: "/photos/sector-artisanat-hero.jpg",
 alt: p("Artisanat ouest-africain, savoir-faire de Guinée-Bissau", "West African crafts, know-how of Guinea-Bissau", "Artesanato oeste-africano, saberes da Guiné-Bissau"),
 breadcrumb: p("Artisanat", "Crafts", "Artesanato"),
 title: p("Investir dans l'artisanat.", "Investing in crafts.", "Investir no artesanato."),
 subtitle: p(
 "Tissage, poterie, sculpture sur bois, vannerie, bijoux, cuir : un patrimoine vivant à structurer en filière d'export premium.",
 "Weaving, pottery, wood carving, basketry, jewellery, leather: a living heritage to structure into a premium export value chain.",
 "Tecelagem, olaria, escultura em madeira, cestaria, joalharia, couro: um património vivo a estruturar em fileira de exportação premium."
 ),
 },
 seo: {
 title: p(
 "Investir dans l'artisanat de Guinée-Bissau | NANDA SÁ",
 "Investing in Guinea-Bissau crafts | NANDA SÁ",
 "Investir no artesanato da Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Panorama de l'artisanat en Guinée-Bissau : tissage, poterie, sculpture, bijoux, cuir, vannerie. Segments premium, savoir-faire, opportunités d'export.",
 "Panorama of crafts in Guinea-Bissau: weaving, pottery, sculpture, jewellery, leather, basketry. Premium segments, know-how, export opportunities.",
 "Panorama do artesanato na Guiné-Bissau: tecelagem, olaria, escultura, joalharia, couro, cestaria. Segmentos premium, saberes, oportunidades de exportação."
 ),
 keywords: "artisanat Guinée-Bissau, tissage Balante, poterie Manjaque, sculpture bois Afrique de l'Ouest, artisanat export premium, boutiques concept",
 },
 presentation: {
 title: p("Un patrimoine vivant, une valeur à révéler.", "A living heritage, a value to reveal.", "Um património vivo, um valor a revelar."),
 paragraphs: p(
 [
 "La Guinée-Bissau abritent des lignées d'artisans reconnues à l'échelle de l'Afrique de l'Ouest : tisserands mancagnes et manjaques, potières balantes, sculpteurs sur bois de Cacheu, vanniers diola, bijoutiers de Bissau. Ces savoir-faire, transmis oralement, portent une esthétique qui trouve aujourd'hui écho auprès des concept stores de Paris, Milan, Lisbonne.",
 "Structurer une filière artisanale premium, c'est offrir aux artisans une rémunération juste et aux acheteurs internationaux une provenance authentique — deux exigences convergentes que les investisseurs peuvent adresser dès aujourd'hui.",
 ],
 [
 "Guinea-Bissau host artisan lineages recognised across West Africa: Manjak and Mancagne weavers, Balanta potters, Cacheu wood sculptors, Diola basket-makers, Bissau jewellers. This know-how, transmitted orally, carries an aesthetic that today resonates with concept stores in Paris, Milan, Lisbon and Bissau.",
 "Structuring a premium craft value chain means offering artisans fair remuneration and international buyers authentic provenance — two converging demands that investors can address today.",
 ],
 [
 "A Guiné-Bissau abrigam linhagens de artesãos reconhecidas em toda a África Ocidental: tecelões manjacos e mancanhas, oleiras balantas, escultores de Cacheu, cesteiros diola, joalheiros de Bissau. Estes saberes, transmitidos oralmente, transportam uma estética que hoje ecoa junto de concept stores em Paris, Milão, Lisboa e Bissau.",
 "Estruturar uma fileira artesanal premium significa oferecer aos artesãos uma remuneração justa e aos compradores internacionais uma proveniência autêntica — duas exigências convergentes que os investidores podem abordar desde hoje.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés de l'artisanat", "Craft key figures", "Dados-chave do artesanato"),
 items: [
 { n: "6+", l: p("Lignées reconnues", "Recognised lineages", "Linhagens reconhecidas"), d: p("Balante, Manjaque, Mancagne, Diola, Papel, Fula.", "Balanta, Manjak, Mancagne, Diola, Papel, Fula.", "Balanta, Manjaco, Mancanha, Diola, Papel, Fula.") },
 { n: "€ 80 M+", l: p("Marché mondial déco ethnique", "Global ethnic decor market", "Mercado mundial deco étnica"), d: p("Croissance 6 %/an — segment premium en expansion.", "6%/year growth — expanding premium segment.", "Crescimento 6%/ano — segmento premium em expansão.") },
 { n: "70 %", l: p("Femmes artisanes", "Women artisans", "Mulheres artesãs"), d: p("Filières à fort impact social.", "High social-impact value chains.", "Fileiras de forte impacto social.") },
 { n: "5", l: p("Coopératives partenaires", "Partner cooperatives", "Cooperativas parceiras"), d: p("Cacheu, Bissau, Adéane, Bignona.", "Cacheu, Bissau, Adéane, Bignona.", "Cacheu, Bissau, Adéane, Bignona.") },
 { n: "x 4-6", l: p("Marge concept store", "Concept store markup", "Margem concept store"), d: p("Écart producteur-vitrine — valeur à capter localement.", "Producer-storefront gap — value to capture locally.", "Diferença produtor-vitrina — valor a captar localmente.") },
 { n: "Peu", l: p("Concurrence structurée", "Structured competition", "Concorrência estruturada"), d: p("Marché premium à conquérir avec méthode.", "Premium market to conquer with method.", "Mercado premium a conquistar com método.") },
 ],
 sources: p(
 "Sources : UNESCO, Chambre des métiers Guinée-Bissau, Direction de l'artisanat Guinée-Bissau, données 2022-2025.",
 "Sources: UNESCO, Guinea-Bissau Chamber of Crafts, Guinée-Bissau Directorate of Crafts, data 2022-2025.",
 "Fontes: UNESCO, Câmara dos ofícios da Guiné-Bissau, Direcção do artesanato da Guiné-Bissau, dados 2022-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments à haute désirabilité internationale.",
 "Four segments with high international desirability.",
 "Quatro segmentos com forte desejabilidade internacional."
 ),
 segments: [
 { h3: p("1. Ateliers coopératifs de production", "1. Cooperative production workshops", "1. Oficinas cooperativas de produção"),
 p: p("Regroupement d'artisans, standardisation qualité, packaging. Ticket : 50 000 à 200 000 €.", "Artisan pooling, quality standardisation, packaging. Ticket: €50k to €200k.", "Agrupamento de artesãos, padronização de qualidade, embalagem. Ticket: 50 000 a 200 000 €.") },
 { h3: p("2. Marques artisanales premium (NANDA SÁ · adjacent)", "2. Premium craft brands (NANDA SÁ-adjacent)", "2. Marcas artesanais premium (adjacentes à NANDA SÁ)"),
 p: p("Positionnement concept stores, luxe éthique. Ticket : 80 000 à 300 000 €.", "Concept stores positioning, ethical luxury. Ticket: €80k to €300k.", "Posicionamento concept stores, luxo ético. Ticket: 80 000 a 300 000 €.") },
 { h3: p("3. Boutiques d'expérience à Bissau", "3. Experience boutiques in Bissau and Bafatá", "3. Lojas de experiência em Bissau e Bafatá"),
 p: p("Vente locale et touristique, adossée aux hôtels premium. Ticket : 40 000 à 120 000 €.", "Local and tourist sales, backed by premium hotels. Ticket: €40k to €120k.", "Venda local e turística, apoiada em hotéis premium. Ticket: 40 000 a 120 000 €.") },
 { h3: p("4. Export B2B (Europe, Amériques, Golfe)", "4. B2B export (Europe, Americas, Gulf)", "4. Exportação B2B (Europa, Américas, Golfo)"),
 p: p("Contenants équitables, traçabilité, certifications. Ticket : 100 000 à 400 000 €.", "Fair-trade containers, traceability, certifications. Ticket: €100k to €400k.", "Contentores equitativos, rastreabilidade, certificações. Ticket: 100 000 a 400 000 €.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "L'artisanat premium se joue autant dans l'atelier que dans le contrat.",
 "Premium crafts play out as much in the workshop as in the contract.",
 "O artesanato premium joga-se tanto na oficina como no contrato."
 ),
 items: p(
 [
 "Standardisation de la qualité et des délais, sans écraser l'authenticité.",
 "Formalisation des artisans (statuts, comptabilité, protection sociale).",
 "Certification internationale (commerce équitable, matériaux durables).",
 "Logistique fragile de l'objet unique — packaging et assurance à structurer.",
 ],
 [
 "Standardisation of quality and lead times without crushing authenticity.",
 "Formalisation of artisans (statuses, accounting, social protection).",
 "International certification (fair trade, sustainable materials).",
 "Fragile logistics of the unique object — packaging and insurance to structure.",
 ],
 [
 "Padronização da qualidade e dos prazos sem esmagar a autenticidade.",
 "Formalização dos artesãos (estatutos, contabilidade, protecção social).",
 "Certificação internacional (comércio justo, materiais sustentáveis).",
 "Logística frágil do objecto único — embalagem e seguros a estruturar.",
 ]
 ),
 closing: p(
 "Ces défis sont ceux d'un métier qui prend son temps. C'est précisément là que se construisent les marques durables.",
 "These challenges belong to a trade that takes its time. It is precisely there that durable brands are built.",
 "Estes desafios pertencem a um ofício que leva o seu tempo. É precisamente aí que se constroem marcas duradouras."
 ),
 },
 pourquoi: {
 title: p("La Maison qui parle aux artisans.", "The House that speaks to artisans.", "A Casa que fala aos artesãos."),
 paragraphs: p(
 [
 "NANDA SÁ est née d'un dialogue avec les coopératives féminines de Cacheu et d'Adéane. Nos Maisons NANDA SÁ, NANDA SÁ Cosmétiques et JOHN TĀDO travaillent déjà avec des artisans locaux. Nous savons construire des ponts entre l'atelier de brousse et la boutique parisienne, avec respect et rigueur.",
 ],
 [
 "NANDA SÁ was born from a dialogue with women's cooperatives in Cacheu and Adéane. Our NANDA SÁ, NANDA SÁ Cosmétiques and JOHN TĀDO Houses already work with local artisans. We know how to build bridges between the bush workshop and the Parisian boutique, with respect and rigour.",
 ],
 [
 "A NANDA SÁ nasceu de um diálogo com as cooperativas femininas de Cacheu e Adéane. As nossas Casas NANDA SÁ, NANDA SÁ Cosmétiques e JOHN TĀDO já trabalham com artesãos locais. Sabemos construir pontes entre a oficina do mato e a loja parisiense, com respeito e rigor.",
 ]
 ),
 bullets: p(
 [
 "Cartographie des artisans et coopératives",
 "Structuration qualité et certification",
 "Marketing premium et concept stores",
 "Logistique export sécurisée",
 ],
 [
 "Mapping of artisans and cooperatives",
 "Quality structuring and certification",
 "Premium marketing and concept stores",
 "Secure export logistics",
 ],
 [
 "Cartografia de artesãos e cooperativas",
 "Estruturação de qualidade e certificação",
 "Marketing premium e concept stores",
 "Logística de exportação segura",
 ]
 ),
 },
 download: {
 title: p("Télécharger la note « Artisanat · Guinée-Bissau ».", "Download the brief « Crafts · Guinea-Bissau ».", "Descarregar a nota « Artesanato · Guiné-Bissau »."),
 body: p(
 "Note préparée par NANDA SÁ : chiffres clés, segments premium, coopératives partenaires, contacts utiles.",
 "Brief prepared by NANDA SÁ: key figures, premium segments, partner cooperatives, useful contacts.",
 "Nota preparada pela NANDA SÁ: dados-chave, segmentos premium, cooperativas parceiras, contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-artisanat.pdf",
 pdfFilename: "nanda-sa-note-artisanat.pdf",
 mailSubject: p("Téléchargement de la note « Artisanat »", "Download of the brief « Crafts »", "Descarga da nota « Artesanato »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Artisanat · Guinée-Bissau ».",
 "Hello, I would like to receive the brief « Crafts · Guinea-Bissau ».",
 "Olá, gostaria de receber a nota « Artesanato · Guiné-Bissau »."
 ),
 },
 contact: {
 title: p("Parlons de votre projet artisanal.", "Let's talk about your craft project.", "Falemos do seu projecto artesanal."),
 body: p(
 "Marque, distributeur, concept store, coopérative, mécène : décrivez votre intention, nous répondons personnellement.",
 "Brand, distributor, concept store, cooperative, patron: describe your intention, we respond personally.",
 "Marca, distribuidor, concept store, cooperativa, mecenas: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "Un objet fait à la main porte un temps qui ne se rattrape pas. C'est là toute sa valeur.",
 "A handmade object carries a time that cannot be caught up with. That is its whole value.",
 "Um objecto feito à mão transporta um tempo que não se recupera. Essa é toda a sua valia."
 ),
 subject: p("Investir dans l'artisanat en Guinée-Bissau", "Invest in Guinea-Bissau crafts", "Investir no artesanato da Guiné-Bissau"),
 },
 ctas: ["NandaSa", "Eleone", "Conseil"],
};

export default artisanat;
